import _get from 'lodash/get'
import React from 'react'
import { View } from 'react-native'
import { tv } from 'tailwind-variants'
import { P, match } from 'ts-pattern'
import { z } from 'zod'

import { mapLegacyIconToPhosphor } from '@nxt-insurance/constants'

import { useFlowsServicesResponses } from '@flows-ui/services/FlowServicesResponsesContext'
import type { Icon as IconProps } from '@flows/core/types/stepContentTypes'
import { IMAGE } from '@ui-kit/assets/images/index.native'
import PhosphorIconBadge from '@ui-kit/components/PhosphorIcon/PhosphorIconBadge'
import UiKitIcon from '@ui-kit/components/SvgIcon'
import { ICON_SIZE } from '@ui-kit/constants'
import { iconSize } from '@ui-kit/styles/size'

const styles = tv({
  slots: {
    container: 'flex flex-row justify-center',
  },
  variants: {
    align: {
      left: 'justify-start',
      center: 'justify-center',
      right: 'justify-end',
    },
  },
})

export const Icon = (props: IconProps) => {
  const servicesResponses = useFlowsServicesResponses()
  const { container } = styles({ align: props.align })

  const iconPath = match(props.path)
    .returnType<string>()
    .with(
      {
        static: P.string,
      },
      (path) => path.static
    )
    .otherwise((path) => z.string().parse(_get(servicesResponses, path.dynamic)))

  // Icon names may be dotted (e.g. `action.close_24`); map by the final segment.
  const iconName = iconPath.split('.').pop() ?? iconPath
  const phosphorName = mapLegacyIconToPhosphor(iconName)

  if (phosphorName) {
    return (
      <View className={container()}>
        <PhosphorIconBadge
          name={phosphorName}
          size={ICON_SIZE[props.size]}
          bgShape={props.bgShape}
          bgColor={props.bgColor}
        />
      </View>
    )
  }

  // Legacy fallback for icons with no Phosphor equivalent.
  const imgSrc = _get(IMAGE.icons[props.size], iconPath).default.src

  const { size, ...iconProps } = props

  return (
    <View className={container()}>
      <View className={iconSize({ size })}>
        <UiKitIcon {...iconProps} imgSrc={imgSrc} />
      </View>
    </View>
  )
}
